'use client';

import { createContext, type Dispatch, type ReactNode, type SetStateAction, useMemo, useState } from 'react';
import type { EventData } from '@/app_lib/types/Gtm';

interface GtmContextInterface {
  pageData: EventData;
  setPageData: Dispatch<SetStateAction<EventData>>;
}

const defaultGtmContext: GtmContextInterface = {
  pageData: {
    // biome-ignore lint/style/useNamingConvention: gtm data
    platformCD: 'own',
  },
  setPageData: () => {},
};

interface GtmProviderProps {
  children: ReactNode;
}

// biome-ignore lint/style/useComponentExportOnlyModules: context should be with provider
export const GtmContext = createContext<GtmContextInterface>(defaultGtmContext);

export const GtmProvider = ({ children }: GtmProviderProps) => {
  const [pageData, setPageData] = useState<EventData>(defaultGtmContext.pageData);

  const gtmState = useMemo(
    () => ({
      pageData,
      setPageData,
    }),
    [pageData],
  );

  return <GtmContext.Provider value={gtmState}>{children}</GtmContext.Provider>;
};
